// extracted by mini-css-extract-plugin
export default {"trTdFC":"trTdFirstChild_trTdFC__IXzng"};